export default class {
    constructor (ModalService, MomentService, localStorageService, TokenService) {
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.localStorageService = localStorageService;
        this.TokenService = TokenService;
    }

    showReleaseNotes (releaseNotes) {
        const hasSeen = 'hasSeenReleaseNotes';
        const valueToStore = `${this.MomentService.getCurrentDate()}-${this.TokenService.getUser().id}`;
        if (this.localStorageService.get(hasSeen) && this.localStorageService.get(hasSeen) === valueToStore) {
            return false;
        }

        return this.ModalService.open({
            template: '<modals-release-note class="wrapper" uib-modal-instance="vm.$uibModalInstance" release-notes="vm.releaseNotes"/>',
            size: 'large',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.releaseNotes = releaseNotes;
            }
        })
            .then(() => this.localStorageService.set(hasSeen, valueToStore))
            .catch(() => this.localStorageService.set(hasSeen, valueToStore))
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/releaseNote/index.js